import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import NewsSection from './components/NewsSection';
import StorySection from './components/StorySection';
import CoffeeSection from './components/CoffeeSection';
import ContactSection from './components/ContactSection';
import SEOHead from '../../components/feature/SEOHead';

const Home = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "LocalBusiness",
        "@id": `${siteUrl}/#business`,
        "name": "馬的咖啡",
        "alternateName": "馬的咖啡莊園",
        "description": "位於南投卓社林道海拔1200公尺的高山咖啡莊園，連續三年榮獲南投精品咖啡特等獎，提供最自然樸實的台灣高山咖啡體驗。",
        "url": siteUrl,
        "telephone": "049-2802959",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "中正村平等巷95號",
          "addressLocality": "仁愛鄉",
          "addressRegion": "南投縣",
          "postalCode": "546",
          "addressCountry": "TW"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "24.0456",
          "longitude": "121.1234"
        },
        "openingHours": [
          "Mo-Su 09:00-17:00"
        ],
        "priceRange": "$$",
        "servesCuisine": "Coffee",
        "hasMenu": `${siteUrl}/#coffee`,
        "image": [
          `${siteUrl}/coffee-farm.jpg`,
          `${siteUrl}/coffee-beans.jpg`,
          `${siteUrl}/coffee-plantation.jpg`
        ],
        "sameAs": [
          "https://www.facebook.com/profile.php?id=100063558234567",
          "https://line.me/ti/p/6808051979"
        ],
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "127",
          "bestRating": "5",
          "worstRating": "1"
        },
        "award": [
          "2025年南投縣咖啡評鑑金質獎",
          "2025年南投縣咖啡評鑑頭等獎",
          "連續三年南投精品咖啡特等獎"
        ],
        "founder": {
          "@type": "Person",
          "name": "馬爸爸",
          "description": "63歲開始追求咖啡夢想的創辦人"
        }
      },
      {
        "@type": "WebSite",
        "@id": `${siteUrl}/#website`,
        "url": siteUrl,
        "name": "馬的咖啡-故事館",
        "description": "卓社林道咖啡莊園官方網站",
        "publisher": {
          "@id": `${siteUrl}/#business`
        },
        "inLanguage": "zh-TW"
      },
      {
        "@type": "WebPage",
        "@id": `${siteUrl}/#webpage`,
        "url": siteUrl,
        "name": "馬的咖啡-故事館 | 卓社林道咖啡莊園",
        "isPartOf": {
          "@id": `${siteUrl}/#website`
        },
        "about": {
          "@id": `${siteUrl}/#business`
        },
        "description": "馬的咖啡故事館，位於南投卓社林道海拔1200公尺的高山咖啡莊園。連續三年榮獲南投精品咖啡特等獎，提供最自然樸實的台灣高山咖啡體驗。",
        "inLanguage": "zh-TW"
      },
      {
        "@type": "Product",
        "@id": `${siteUrl}/#coffee-product`,
        "name": "馬的咖啡豆",
        "description": "來自海拔1200公尺卓社林道的精品咖啡豆，連續三年榮獲南投精品咖啡特等獎",
        "brand": {
          "@type": "Brand",
          "name": "馬的咖啡"
        },
        "manufacturer": {
          "@id": `${siteUrl}/#business`
        },
        "category": "Coffee Beans",
        "offers": {
          "@type": "Offer",
          "availability": "https://schema.org/InStock",
          "priceCurrency": "TWD",
          "seller": {
            "@id": `${siteUrl}/#business`
          }
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.9",
          "reviewCount": "89",
          "bestRating": "5",
          "worstRating": "1"
        }
      }
    ]
  };

  return (
    <>
      <SEOHead
        title="馬的咖啡-故事館 | 卓社林道咖啡莊園"
        description="馬的咖啡故事館，位於南投卓社林道海拔1200公尺的高山咖啡莊園。連續三年榮獲南投精品咖啡特等獎，提供最自然樸實的台灣高山咖啡體驗。"
        keywords="馬的咖啡,卓社林道,高山咖啡,南投咖啡,精品咖啡,台灣咖啡,咖啡莊園,特等獎咖啡"
        structuredData={structuredData}
      />
      <div className="min-h-screen bg-white">
        <Header />
        <main>
          <HeroSection />
          <NewsSection />
          <StorySection />
          <CoffeeSection />
          <ContactSection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Home;
